import instance from "../../utils/axios";

export const verifyOtp = async (formData) => {
  return await instance.post("/verify-otp", formData);
};
